import {useMutation} from '@tanstack/react-query'
import {httpLogout} from '@features/user/http/user.http.ts'
import {errorHandler} from '@utilities/helpers.ts'
import {useAuthStore} from '@features/user/store/store.ts'

export const useLogout = () => {
    const resetAuthTokens = useAuthStore(store => store.resetAuthTokens)

    return useMutation({
        mutationFn: httpLogout,
        onSuccess: () => {
            resetAuthTokens()
        },
        onError: errorHandler
    })
}
